"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IC3PollingV1InterestedResources = /** @class */ (function () {
    function IC3PollingV1InterestedResources() {
    }
    IC3PollingV1InterestedResources.ConversationProperties = "/v1/users/ME/conversations/ALL/properties";
    IC3PollingV1InterestedResources.ConversationMessages = "/v1/users/ME/conversations/ALL/messages";
    IC3PollingV1InterestedResources.Threads = "/v1/threads/ALL";
    IC3PollingV1InterestedResources.Contacts = "/v1/users/ME/contacts/ALL";
    return IC3PollingV1InterestedResources;
}());
exports.default = IC3PollingV1InterestedResources;
//# sourceMappingURL=IC3PollingV1InterestedResources.js.map